import { render, staticRenderFns } from "./DrugSelect.vue?vue&type=template&id=c572c0a4&"
import script from "./DrugSelect.vue?vue&type=script&lang=js&"
export * from "./DrugSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports